import * as React from 'react';
import { FullHeightSection, SectionContent } from '@components/Sections/Sections.s';
import { PhoneFrame } from '@components/PhoneFrame/PhoneFrame';
import { LogoVideo } from '@components/Videos/LogoVideo';
import { AnimatedBaseline } from '@components/AnimatedBaseline/AnimatedBaseline';
import {
  SectionOneBackground, SectionOneBackgroundImg, SectionOnePhoneFrame, BaselineWraper, SectionOnePhoneBackground,
  IlluCesar, IlluDarthvader, IlluGameboy, IlluIpod, IlluPalaischinois, BadgesWraper
} from './SectionOne.s';
import { GoogleBlack, AppleBlack } from '@components/Badges';
import { mobileBreakpoint } from '@styles/layout';

type SectionOneProps = {
  windowWidth: number;
};

export const SectionOne = (props: SectionOneProps) => (
  <FullHeightSection>
    <SectionContent fullHeight={true}>
      <SectionOneBackground>
        <SectionOneBackgroundImg />
      </SectionOneBackground>
      {(props.windowWidth >= mobileBreakpoint) && (
        <SectionOnePhoneFrame>
          <SectionOnePhoneBackground>
            <IlluCesar />
            <IlluDarthvader />
            <IlluGameboy />
            <IlluIpod />
            <IlluPalaischinois />
          </SectionOnePhoneBackground>
          <PhoneFrame>
            <LogoVideo />
          </PhoneFrame>
        </SectionOnePhoneFrame>
      )}
      <BaselineWraper>
        <AnimatedBaseline />
      </BaselineWraper>
      <BadgesWraper>
        <GoogleBlack />
        <AppleBlack />
      </BadgesWraper>
    </SectionContent>
  </FullHeightSection>
);



// WEBPACK FOOTER //
// src/app/src/components/SectionOne/SectionOne.tsx